import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useConnectedUser, UserType } from '../context/connected-user.context';
import { SectionTitle } from '../design-system/title';
import { StakingData } from '../web3/model/staking.model';
import { StakingDataView } from '../components/round/staking/staking-view';

export const StakingRoundPage: React.FC = () => {
    const { stakingRoundId } = useParams();
    const [searchParams] = useSearchParams();
    const cdkContract = useConnectedUser().contract;
    const [round, setRound] = useState<StakingData | undefined>(undefined);

    const userType = (searchParams.get('userType') as UserType) ?? 'USER';

    useEffect(() => {
        if (stakingRoundId && cdkContract) {
            cdkContract.stakingFacet.getStakingRoundDetails(stakingRoundId).then((round) => {
                setRound(round);
            });
        }
    }, [stakingRoundId, cdkContract]);

    if(!stakingRoundId) {
        return <div>Invalid staking round id</div>;
    }
    return (
        <div>
            <SectionTitle title="Staking Round Details" />
            {round && <StakingDataView stakingRoundId={stakingRoundId} roundDetails={round} userType={userType} />}
        </div>
    );
};
